export default "__VITE_ASSET__DrdsfzDQ__"